import React, { useState, useEffect } from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { EXTERNAL_URLS, getTextAppHost, getUrlImgStore } from "../utils/url/url";
import { DATA_ACQUISITION_STATUS } from "../components/Loader/Loader.constants";
import { selectorSystemDataAcquisitionStatus } from "../store/system/selectors";
import Scroll from "../components/Scroll/Scroll";
import CloseButton from "../components/Button/CloseButton/CloseButton";
import Button from "../components/Button/Button";
import Logotype from "../components/Logotype/Logotype";
import ImageWithLoader from "../components/Loader/ImageWithLoader";
import { selectorSetting } from "../store/settings/selectors";
import { SETTING } from "../utils/settings/constants";
import useLockBodyScroll from "../hooks/useLockBodyScroll";

import styles from "./TextModePage.module.scss";

const googlePlaySrc = getUrlImgStore("android");
const appStoreSrc = getUrlImgStore("ios");

const TextModePage = () => {
  const { t } = useSharedTranslation();
  const textMode = useSelector(selectorSetting(SETTING.textMode.id));
  const dataAcquisitionStatus = useSelector(selectorSystemDataAcquisitionStatus);
  const [isTextModePopupVisible, setIsTextModePopupVisible] = useState(false);

  useLockBodyScroll(isTextModePopupVisible);

  // Show "Slow internet connection" notification
  useEffect(() => {
    if (dataAcquisitionStatus === DATA_ACQUISITION_STATUS.LOW && !textMode) {
      setIsTextModePopupVisible(true);
    }
  }, [dataAcquisitionStatus, textMode]);

  if (!isTextModePopupVisible) {
    return null;
  }

  return (
    <div className={styles["text-mode-page"]}>
      <div className={styles["header-page"]}>
        <CloseButton
          onClick={() => {
            setIsTextModePopupVisible(false);
          }}
        />
      </div>
      <div className={styles["container"]}>
        <div className={styles["logo-container"]}>
          <Logotype
            className={styles["logo"]}
            isShowRegistered
            isShowLogoLinks
            isShowLogoWritingsLabel
          />
        </div>

        <Scroll autoHeight autoHeightMax="65vh">
          <div className={styles["content-container"]}>
            <div className={styles["title"]}>{t("textModePageTitle")}</div>
            <p>{t("try_switching_to_text_mode")}</p>
              <Button rootTagName={"a"} href={getTextAppHost()} className={styles["text-mode-button"]}>{t("switch_to_text_mode")}</Button>
            <div className={styles["footer-container"]}>
              <p dangerouslySetInnerHTML={{ __html: t("or_download_our_apps") }} />
              <div className={styles["btn-group"]}>
                <a
                  className={styles["app-sore-button"]}
                  href={EXTERNAL_URLS.iosAPP}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ImageWithLoader src={appStoreSrc}>{t("appleStoreButton")}</ImageWithLoader>
                </a>
                <a
                  className={styles["google-play-button"]}
                  href={EXTERNAL_URLS.androidApp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ImageWithLoader src={googlePlaySrc}>{t("googlePlayButton")}</ImageWithLoader>
                </a>
              </div>
            </div>
          </div>
        </Scroll>
      </div>
    </div>
  );
};

TextModePage.propTypes = {
  Link: PropTypes.any,
  LinkButton: PropTypes.any,
};

export default TextModePage;
